import {
  AutoPayHistoryActionType,
  AutoPayHistoryState
} from 'redux/autoPayHistory/typings'

export const initState: AutoPayHistoryState = {
  isLoading: false,
  response: {
    payments: []
  },
  error: null
}

const autoPayHistoryReducer = (
  // eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
  state: AutoPayHistoryState = initState,
  action: AutoPayHistoryActionType
): AutoPayHistoryState => {
  switch (action.type) {
    case 'GET_AUTO_PAY_HISTORY':
      return {
        ...state,
        isLoading: true,
        error: null
      }
    case 'GET_AUTO_PAY_HISTORY_FULFILLED':
      return {
        ...state,
        isLoading: false,
        response: action.payload.response
      }
    case 'GET_AUTO_PAY_HISTORY_FAILED':
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      }
    default:
      return state
  }
}

export default autoPayHistoryReducer
